import React from 'react';
import SponsorshipForm from '../components/SponsorshipForm';
import MySponsorshipsTable from '../components/MySponsorshipsTable';

const NewSponsorshipPage = ({ currentUser }) => {
  const handleSponsorshipCreated = (sponsorship) => {
    window.location.href = `/sponsorships/${sponsorship.id}`;
  };

  return (
    <div style={{ background: '#f7eef2', minHeight: '100vh', paddingTop: '88px', paddingBottom: '80px' }}>
      <div className="container" style={{ maxWidth: 1120 }}>
        <div style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', borderRadius: 24, padding: '34px 38px', color: '#fff', marginBottom: 24, boxShadow: '0 24px 60px rgba(124,40,55,0.18)' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,0.14)', borderRadius: 999, padding: '8px 14px', fontSize: '0.8rem', fontWeight: 700, marginBottom: 14 }}>
            Parrainage
          </div>
          <h1 style={{ fontSize: 'clamp(2rem,4vw,3.2rem)', fontWeight: 800, marginBottom: 10, letterSpacing: '-0.03em' }}>Créer une demande de parrainage</h1>
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.92)', lineHeight: 1.75, maxWidth: 760 }}>
            Propose l'entrée d'un nouveau membre dans l'association en lançant une demande claire, suivie et conforme aux règles de cooptation.
          </p>
        </div>

        <div className="row justify-content-center g-4">
          <div className="col-lg-8">
            <div style={{ background: '#fff', borderRadius: 24, border: '1px solid rgba(124,40,55,0.12)', boxShadow: '0 18px 44px rgba(124,40,55,0.08)', padding: '34px 36px' }}>
              <h2 style={{ color: '#2c0e16', fontSize: '1.6rem', fontWeight: 800, marginBottom: 10 }}>Nouvelle demande</h2>
              <p style={{ color: '#7a4050', lineHeight: 1.75, marginBottom: 28 }}>
                Indique l'email du filleul et le niveau demandé. La demande sera ensuite suivie par les soutiens requis selon le niveau visé.
              </p>

              <SponsorshipForm
                currentUser={currentUser}
                onSubmit={handleSponsorshipCreated}
              />
            </div>

            <div style={{ background: '#fff', borderRadius: 24, border: '1px solid rgba(124,40,55,0.12)', boxShadow: '0 18px 44px rgba(124,40,55,0.08)', padding: '28px 30px', marginTop: 24 }}>
              <h3 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, marginBottom: 18 }}>
                ℹ️ Rappel des règles de cooptation
              </h3>
              <div className="table-responsive">
                <table className="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th style={{ color: '#7c2837', fontWeight: '700' }}>Niveau</th>
                      <th style={{ color: '#7c2837', fontWeight: '700' }}>Parrains requis</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>Adhérent Actif</strong></td>
                      <td>1 Membre Fondateur <strong>OU</strong> 3 Adhérents Actifs</td>
                    </tr>
                    <tr>
                      <td><strong>Adhérent Participant</strong></td>
                      <td>1 Membre Fondateur <strong>OU</strong> 3 Adhérents Participants</td>
                    </tr>
                    <tr>
                      <td><strong>Adhérent Sympathisant</strong></td>
                      <td>1 Membre Fondateur <strong>OU</strong> 2 Adhérents Sympathisants</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 24, border: '1px solid rgba(124,40,55,0.12)', boxShadow: '0 18px 44px rgba(124,40,55,0.08)', padding: '28px 30px', marginTop: 24 }}>
              <h3 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, marginBottom: 18 }}>
                📋 Mes cooptations
              </h3>
              <p style={{ color: '#7a4050', lineHeight: 1.75, marginBottom: 18, fontSize: '0.92rem' }}>
                Suivez le statut de vos demandes de cooptation et l'inscription de vos filleuls.
              </p>
              <MySponsorshipsTable currentUserId={currentUser?.id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSponsorshipPage;